export default {
	PROFESSIONAL: 'Professional',
	SPECIALTY: 'Specialty',
	SERVICE: 'Service'
}


// WEBPACK FOOTER //
// ./src/constants/multipleSearchOptionTypes.js